import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Country {
  isoCode: string;
  name: string;
  capitals: string[];
  flag: string;
  continent: string;
  rank: number;
  flagGroup: number;
}

export interface Countries { [index: string]: Country; }

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private _http = inject(HttpClient);

  private _countries: Countries;

  getCountries(): Observable<Countries> {
    if (this._countries)
      return of(this._countries);
    return this._http.get('assets/data.csv', { responseType: 'text' }).pipe(map(data => {
      const countries: Countries = {};
      for (const line of data.split(/\r?\n/)) {
        const [name, capital, flag, isoCode, continent, rank, flagGroup] = line.split(/;/);
        if (!isoCode)
          continue;
        if (isoCode in countries) {
          countries[isoCode].capitals.push(capital);
        } else {
          countries[isoCode] = {
            isoCode,
            name,
            capitals: [capital],
            flag: `assets/flags/${flag}.svg`,
            continent,
            rank: +rank,
            flagGroup: +flagGroup
          };
        }
      }
      this._countries = countries;
      return countries;
    }));
  }
}
